import React from 'react';
import { useSelector } from 'react-redux';
import Template from '../Contexts/Template';
export default function OverlayContainer(props) {
    const currentTemplate = useSelector((state) => state.TemplateStack.currentTemplate);
    return React.createElement(Template.Provider, { value: currentTemplate }, props.children);
}
